import { CoachCompany } from '../../../lib/types/models/ol/coach-company/coach-company'
import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCoachCompany({ id, olId }: OlRateIdInput) {
  return restApiClient
    .url(constructApiUrl(API.ols.getCoachCompany.url, { id, olId }))
    .get<CoachCompany>()
}
